import { render, staticRenderFns } from "./dropdownList.vue?vue&type=template&id=37cdef21&scoped=true"
import script from "./dropdownList.vue?vue&type=script&lang=js"
export * from "./dropdownList.vue?vue&type=script&lang=js"
import style0 from "./dropdownList.vue?vue&type=style&index=0&id=37cdef21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cdef21",
  null
  
)

export default component.exports